<template>
  <div class="signature-pad mt-3">
    <table style="width: 100%;">

      <tr v-if="isCheck === false">
        <td>
          <div class="pdf-item" :componentvalue="currentField.text">
            <el-form-item
                label="Signing Authority">
              <el-input v-model="currentField.text" v-bind="attributesBinding" >
              </el-input>
            </el-form-item>
          </div>

        </td>

      </tr>
      <tr v-if="isCheck === false || (currentField.componentValue && !/\.(png|jpg|jpeg|webp)$/i.test(currentField.componentValue) && !currentField.componentValue.startsWith('data:image/'))">
        <td colspan="4" class="img-fluid">
          <div class="d-flex justify-content-end">
            <VueSignaturePad
                id="signature"
                width="100%"
                height="200px"
                ref="signaturePad"
                :options="options"
                v-bind="attributesBinding"
                @end="drawSignature"
            />
          </div>
          <div>
            <p class="text-success d-flex justify-content-end mt-2" v-if="isSetTime === true">
              Your signature confirmed successfully
              <span>
                <app-icon class="text-success" name="check-square"/>
              </span>
            </p>
          </div>
          <div class="mt-2 mb-2 w-100 d-flex justify-content-end align-items-center d-print-none">
            <button @click.prevent="undo" class="btn btn-danger mr-2" v-bind="attributesBinding">Undo</button>
            <button @click.prevent="save" v-if="show !== true" class="btn btn-success" v-bind="attributesBinding">Save</button>
          </div>
        </td>
      </tr>
      <tr v-if="isCheck === false">
        <td>
          <div class="pdf-item" :componentvalue="currentField.description">
            <el-form-item
                label="Signature Date">
              <app-input
                  class="col-6"
                  type="date"
                  placeholder="Pick a day"
                  v-model="currentField.description"
                  v-bind="attributesBinding"
              />
            </el-form-item>
          </div>

        </td>
      </tr>

      <tr v-if="currentField.text !== 'SignaturePad'">
        <td>
          <span style="font-size: 13px" v-html="formatMultiline(currentField.text)"></span>
        </td>
      </tr>
      <tr v-if="isCheck === true">
        <td colspan="2" style="width: 50%;">
          <app-avatar
              v-model="checkUrl"
              :title="$t('avatars')"
              style="width: 100%;"
              :imgResponsiveness="'img-fluid'"
              class="mr-2 d-flex justify-content-end"
              avatar-class="avatars-w-200"
              :img="imageUrl"
              :alt-text="$t('not_found')"
              type="signature"
          />
        </td>
        <td colspan="2" style="width: 50%;">
          <div class="d-flex justify-content-end d-print-none" v-if="userRole.company_id !== 1 && currentField.disabled == false">
            <a href="#" @click.prevent="isCheck = !isCheck">Change Signature</a>
          </div>
        </td>
      </tr>

      <tr v-if="!['TExt', 'Text'].includes(currentField.description)">
        <td>
          <span style="font-size: 13px">{{ currentField.description }}</span>
        </td>
      </tr>
    </table>
  </div>
</template>



<script>
// import { createLogger } from 'vuex';
export default {
  name: "SignaturePad",
  props: ['currentField'],
  data: () => ({
    options: {
      penColor: "#000",
    },
    show: false,
    checkUrl: '',
    isCheck: null,
    isSetTime: false,
  }),
  watch: {
    'currentField.description': function (newDate) {
      if (newDate) {
        this.currentField.description = this.formatDate(newDate);
      }
    },
    isCheck(newVal) {
      if (newVal === false) {
        this.resizeSignatureWhenVisible();
      }
    }

  },
  methods: {

    formatDate(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();
      const monthName = date.toLocaleString('default', { month: 'short' });

      return `${day}-${monthName}-${year}`;
    },

    drawSignature() {
      // Get the signature data here
      // const data = this.$refs.signaturePad.toDataURL();
      this.isCheck = false
      // Use the data (e.g., display it in an image element)
    },
    undo() {
      this.show = false;
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      this.isSetTime = true;
      setTimeout(() => {
        this.isSetTime = false;
      }, 2000)
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      this.show = true;
      this.currentField.componentValue = data;
    },
    resizeSignatureWhenVisible() {
      this.$nextTick(() => {
        const el = this.$refs.signaturePad?.$el;

        if (!el) return;

        const observer = new MutationObserver(() => {
          if (el.offsetParent !== null) {
            this.$refs.signaturePad.resizeCanvas();
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          attributes: true,
          childList: true,
          subtree: true,
        });
      });
    },
    formatMultiline(text) {
      return text ? text.replace(/\n/g, '<br>') : '';
    }

  },
  created(){
    this.$hub.$on('printInProgress', (data) => {
      this.show = true;
      this.isCheck = true;
    });
  },
  mounted() {
    if(this.currentField.componentValue && this.currentField.componentValue.length == 0){
      this.isCheck = false
    }
    else{
      // Check if signature exists either as a common image file OR as a base64 data URL
      const isImageFile = this.currentField.componentValue && 
        /\.(png|jpg|jpeg|webp)$/i.test(this.currentField.componentValue);
      
      if(this.currentField.componentValue && 
         (isImageFile || this.currentField.componentValue.startsWith('data:image/'))){
        this.isCheck = true;
        // If we have a base64 signature, load it into the canvas
        if(this.currentField.componentValue.startsWith('data:image/')){
          this.$nextTick(() => {
            if(this.$refs.signaturePad){
              this.$refs.signaturePad.fromDataURL(this.currentField.componentValue);
            }
          });
        }
      }else{
          this.isCheck =  false
      }
    }
    this.resizeSignatureWhenVisible();
  },
  computed: {
    imageUrl(){
      const image = new Image();
      image.src = this.currentField.componentValue;
      image.onload = () => {
        // Image exists, set the actual image URL
        this.currentField.componentValue = this.currentField.componentValue;

      };
      image.onerror = () => {
        // Image doesn't exist, set the dummy image URL
        this.currentField.componentValue = '/signaturePad.png';
      };
      return this.currentField.componentValue;
    },
    attributesBinding() {
      var attr = {};

      if (this.currentField.disabled) {
        attr.disabled = this.currentField.disabled;
      }
      return attr;
    },
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
    inputShow() {
      return this.$store.state.inputMode;
    }
  },
};
</script>

<style>
#signature {
  /*border: double 3px transparent;*/
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.container {
  width: 100%;
  padding: 8px 16px;
}

.buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}
</style>
